import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
const StarField = () => {
  const stars = Array.from({
    length: 30
  }, (_, i) => ({
    id: i,
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
    size: Math.random() * 2.5 + 1,
    duration: Math.random() * 3 + 2,
    delay: Math.random() * 4
  }));
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-1">
      {stars.map(star => <div key={star.id} className="absolute rounded-full bg-gold-300 star" style={{
      top: star.top,
      left: star.left,
      width: star.size,
      height: star.size,
      '--duration': `${star.duration}s`,
      '--delay': `${star.delay}s`
    } as React.CSSProperties} data-id="element-2" />)}
    </div>;
};
export function FinalCTA() {
  return <section className="relative bg-navy-900 py-24 px-4 overflow-hidden" data-id="element-3">
      <StarField data-id="element-4" />

      {/* Center glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-5">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] rounded-full opacity-10 blur-3xl" style={{
        background: 'radial-gradient(ellipse, #c9a84c, transparent)'
      }} data-id="element-6" />
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-8">
          <div className="flex justify-center gap-1 mb-8" data-id="element-9">
            {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-gold-400 fill-gold-400" data-id="element-10" />)}
          </div>

          <h2 className="font-playfair text-4xl md:text-6xl font-bold leading-tight mb-4" data-id="element-11">
            <span className="gold-gradient-text" data-id="element-12">Recupera tu Vida,</span>
            <br data-id="element-13" />
            <span className="text-cream" data-id="element-14">tu Pareja y tu Energía.</span>
          </h2>

          <p className="font-playfair text-2xl md:text-3xl text-cream/70 italic mb-12" data-id="element-15">
            Esta noche puede ser diferente.
          </p>

          <button onClick={() => {
          if (typeof (window as any).fbq === 'function') {
            ;
            (window as any).fbq('track', 'AddToCart', {
              value: 6.39,
              currency: 'USD',
              content_name: 'Sueño Profundo'
            });
          }
          window.location.href = 'https://novadigitalventures.com/cart/42535353811015:1';
        }} className="cta-glow gold-gradient-bg text-navy-900 font-lato font-black text-lg md:text-xl px-10 py-5 rounded-full uppercase tracking-wide hover:scale-105 transition-transform duration-200 cursor-pointer mb-6" data-id="element-16">
            EMPEZAR AHORA — SOLO $6.39
          </button>

          <div className="flex flex-wrap items-center justify-center gap-4 mb-10 text-cream/50 font-lato text-sm" data-id="element-17">
            {['Acceso inmediato', 'Garantía 7 días', 'Pago seguro'].map(item => <span key={item} className="flex items-center gap-1" data-id="element-18">
                  <Check size={13} className="text-gold-400" data-id="element-19" />
                  {item}
                </span>)}
          </div>

          <p className="font-lato text-cream/30 text-sm tracking-widest uppercase" data-id="element-20">
            Guía 2026 · Validada por Miles de Padres Hispanos
          </p>
        </motion.div>
      </div>
    </section>;
}